import { createContext, useContext, useState } from 'react';
import GlobalBanner from './globalBanner';

const BannerContext = createContext(null);

export const useBanner = () => {
  const context = useContext(BannerContext);
  if (!context) {
    throw new Error('useBanner must be used within a BannerProvider');
  }
  return context;
};

export function BannerProvider({ children }) {
  const [banner, setBanner] = useState({
    open: false,
    severity: 'error',
    message: ''
  });

  const showBanner = (message, severity = 'error') => {
    setBanner({ open: true, message, severity });
  };

  const hideBanner = () => {
    setBanner((prev) => ({ ...prev, open: false }));
  };

  return (
    <BannerContext.Provider value={{ showBanner, hideBanner }}>
      <GlobalBanner {...banner} onClose={hideBanner} />
      {children}
    </BannerContext.Provider>
  );
}
